import { UserService } from 'src/app/services/user.service';
import { Component, Input, SimpleChanges, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, ElementRef, NgZone, DoCheck, OnChanges, TemplateRef } from '@angular/core'
import { DocumentoService } from '../../services/documento.service';
import { WizardComponent } from 'angular-archwizard';
import { MatDialog, MatSnackBar, MatStepper } from '@angular/material';
import { crearBorradorComponent } from '../borradores/crearBorrador/crearBorrador.component';
import { NgxSpinnerService } from 'ngx-spinner';

//Prueba NGRX STORE
import { Store } from '@ngrx/store';
import { Form } from 'src/app/models/form.model';
import { FilemakerService } from 'src/app/services/filemaker.service';
import { Router } from '@angular/router';
import * as FormActions from '../../reducers/actions/forms.actions';
import { GLOBAL } from 'src/app/services/global';
import { BorradorStorageService } from '../../services/borrador-storage.service';

import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { AppSettings } from 'src/app/services/constants';
import { BorradoresComponent } from '../borradores/borradores.component';
declare const swal: any;

interface AppState {
    form: Form;
}

@Component({
    selector: "msw-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.css"],
    providers: [DocumentoService, UserService, FilemakerService]
})

export class NavbarComponent implements OnInit, AfterViewInit, DoCheck, OnChanges {

    @Input() form: Form;
    @Input() title: Form;
    tabs = [];
    actualForm = [];
    tempForm;
    @ViewChild('wizard') wizard: WizardComponent;
    wizardSteps: Array<Object>;
    tempWizard = [];
    start = 0;
    end = 0;
    limit = 4;
    actual = 0;
    avance: boolean = false;
    data = [];
    formulariofinal;
    resumen
    listo = true
    public generico = GLOBAL.generico;

    MAX_STEP = 4;
    page = 0;
    totalSteps = 16;
    step = 0;
    minStepAllowed = 0;
    maxStepAllowed = this.MAX_STEP - 1;

    totalPages = Math.ceil(this.totalSteps / this.MAX_STEP);

    @ViewChild("stepper") private myStepper: MatStepper;

    forms = AppSettings.forms;
    draftName: string = '';
    filteredOptions: any[] = [];
    allowNewOption = true;

    constructor(private _documentoService: DocumentoService,
        private _changeDetectionRef: ChangeDetectorRef,
        private dialog: MatDialog, private store: Store<AppState>,
        private spinner: NgxSpinnerService, private _userService: UserService,
        private snackBar: MatSnackBar, private filemaker: FilemakerService,
        private _router: Router,
        private borradorStorageService: BorradorStorageService,
        private elementRef: ElementRef,
        private ngZone: NgZone,
    ) {
        this.wizardSteps = [];
    }


    ngOnInit() {
        if (this.generico == true) {
            this.getDocumentos(localStorage.getItem("form"));
        } else {
            this.getDocumentos(this.form);
        }
    }

    ngAfterViewInit() {
        this.rerender();
    }

    ngDoCheck() {
        this._changeDetectionRef.detectChanges();
        if (localStorage.getItem("resumen")) {
            this.resumen = JSON.stringify(localStorage.getItem("resumen"))
        } else {
            this.resumen = JSON.stringify(false)
        }

        const headers = this.elementRef.nativeElement.querySelectorAll("mat-step-header");
        const lines = this.elementRef.nativeElement.querySelectorAll(".mat-stepper-horizontal-line");

        if (headers.length > 0 && lines.length > 0) {
            this.ngZone.run(() => {
                this.rerender();
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.MAX_STEP = 4;
        this.page = 0;
        this.totalSteps = 16;
        this.step = 0;
        this.minStepAllowed = 0;
        this.maxStepAllowed = this.MAX_STEP - 1;
        this.totalPages = Math.ceil(this.totalSteps / this.MAX_STEP);

        if (this.generico == true) {
            this.getDocumentos(localStorage.getItem("form"));
            this.rerender();

        } else {

            this.getDocumentos(localStorage.getItem("form"));
            this.rerender();
        }

    }


    onOptionSelected(event: any) {
        this.draftName = event.option.value; // Actualiza el modelo con la selección
    }

    rerender() {
        const headers = this.elementRef.nativeElement.querySelectorAll("mat-step-header");
        const lines = this.elementRef.nativeElement.querySelectorAll(".mat-stepper-horizontal-line");

        for (let h of headers) {
            let str = h.getAttribute("aria-posinset");
            // If the step index is in between min and max allowed indexes, display it into view, otherwise set as none
            if (
                str !== null &&
                Number.parseInt(str) - 1 >= this.minStepAllowed &&
                Number.parseInt(str) - 1 <= this.maxStepAllowed
            ) {
                h.style.display = "flex";
            } else {
                h.style.display = "none";
            }
        }

        // If the line index is between min and max allowed indexes, display it in view, otherwise set as none
        // One thing to note here: length of lines is 1 less than length of headers
        // For eg, if there are 8 steps, there will be 7 lines joining those 8 steps
        for (let [index, l] of lines.entries()) {
            if (index >= this.minStepAllowed && index < this.maxStepAllowed) {
                l.style.display = "block";
            } else {
                l.style.display = "none";
            }
        }
    }

    changeMinMaxSteps(isForward = true) {
        if (this.step < this.minStepAllowed || this.step > this.maxStepAllowed) {
            if (isForward) {
                this.page++;
            } else {
                this.page--;
            }

            const pageMultiple = this.page * this.MAX_STEP;

            // maxStepAllowed will be the least value between minStep + MAX_STEP and total steps
            // minStepAllowed will be the least value between pageMultiple and maxStep - MAX_STEP
            if (pageMultiple + this.MAX_STEP - 1 <= this.totalSteps - 1) {
                this.maxStepAllowed = pageMultiple + this.MAX_STEP - 1;
                this.minStepAllowed = pageMultiple;
            } else {
                this.maxStepAllowed = this.totalSteps - 1;
                this.minStepAllowed = this.maxStepAllowed - this.MAX_STEP + 1;
            }
        }

        this.rerender();
    }

    getDocumentos(id) {

        this.spinner.show()
        this.wizardSteps = [];
        this.data = [];
        this.actual = 0;
        this.start = 0;
        this.end = 0;
        this.limit = 4;
        this._documentoService.getDocumento().subscribe(
            response => {
                for (let x = 0; x < this.forms.length; x++) {
                    if (this.forms[x].name == id) {
                        let promise = new Promise((resolve, reject) => {
                            for (let t = 0; t < this.forms[x].tabs.length; t++) {
                                this.wizardSteps.push(this.forms[x].tabs[t])

                            }
                            resolve(this.wizardSteps)
                        })

                        promise.then((wizardSteps: Array<any>) => {
                            this.totalSteps = wizardSteps.length;
                            this.data = wizardSteps
                            this.start = 0;
                            this.end = this.start + this.limit;
                            this.rerender();
                        })
                    }
                }

                this.spinner.hide();
            },
            error => {
                console.log("Error", error)
                this.spinner.hide();
            }
        )
    }

    changeResumen() {
        localStorage.setItem("resumen", JSON.stringify(false))
        this.resumen = JSON.stringify(false)

    }

    splitCamelCase(value: string): string {
        if (!value) return '';
        return value.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    }

    next(wizard) {
        let archivos = JSON.parse(localStorage.getItem("archivos_marcados"));
        let hay_error = false;
        let name_error = "";

       /*  this.forward(wizard);
        return */
        if (wizard.valid) {
            console.log(wizard.valid);

            for (let i = 0; i < wizard.valid.length; i++) {
                const validRow = wizard.valid[i];

                if (JSON.parse(localStorage.getItem(validRow))) {
                    if (JSON.parse(localStorage.getItem(validRow)).length == 0) {
                        let newWord = this.splitCamelCase(validRow)
                        name_error = newWord
                        hay_error = true;
                    }
                } else {
                    let newWord = this.splitCamelCase(validRow)
                    name_error = newWord
                    hay_error = true;
                }
            }


            if (JSON.parse(localStorage.getItem('declaracion')) && JSON.parse(localStorage.getItem('declaracion')).length == 0) {
                hay_error = true;
                name_error = "declaración jurada"
            } else {
                let personeria = JSON.parse(localStorage.getItem('declaracion'))
                if (personeria[0].plano == " " || personeria[0].plano === "SI") {
                    const { denominado, elaborado, profesion } = personeria[0];

                    const denominacionInvalida = !denominado || !denominado.toString().trim();
                    const elaboradoInvalido = !elaborado || !elaborado.toString().trim();
                    const profesionInvalida = !profesion || !profesion.toString().trim();

                    if (denominacionInvalida || elaboradoInvalido || profesionInvalida) {
                        hay_error = true;
                        name_error = "declaración jurada";
                    }
                }
            }

            if (JSON.parse(localStorage.getItem('propietarioRepresentante')) && JSON.parse(localStorage.getItem('propietarioRepresentante')).length > 0) {
                console.log(JSON.parse(localStorage.getItem('personeria')));

                if (JSON.parse(localStorage.getItem('personeria')) && JSON.parse(localStorage.getItem('personeria')).length == 0) {
                    hay_error = true;
                    name_error = "declaración del representante"
                } else {
                    let personeria = JSON.parse(localStorage.getItem('personeria'))

                    console.log("aca", personeria[0]);

                    if (personeria[0].aFecha.trim() == "") hay_error = true; name_error = "declaración representante";
                    if (personeria[0].aMediante.trim() == "") hay_error = true; name_error = "declaración representante";
                    if (personeria[0].escrituraFecha.trim() == "") hay_error = true; name_error = "declaración representante";
                    if (personeria[0].medInstrumento.trim() == "") hay_error = true; name_error = "declaración representante";
                    if (personeria[0].notario.trim() == "") hay_error = true; name_error = "declaración representante";
                    if (personeria[0].oFecha.trim() == "") hay_error = true; name_error = "declaración representante";
                    if (personeria[0].oMediante.trim() == "") hay_error = true; name_error = "declaración representante";

                }
            }

            if (JSON.parse(localStorage.getItem('calculistas')) && JSON.parse(localStorage.getItem('calculistas')).length > 0) {
                if (JSON.parse(localStorage.getItem('calculistaProfesional')) && JSON.parse(localStorage.getItem('calculistaProfesional')).length == 0) {
                    hay_error = true;
                    name_error = "profesional del calculista"
                }
            }

            if (JSON.parse(localStorage.getItem('constructora')) && JSON.parse(localStorage.getItem('constructora')).length > 0) {
                if (JSON.parse(localStorage.getItem('constructoraProfesional')) && JSON.parse(localStorage.getItem('constructoraProfesional')).length == 0) {
                    hay_error = true;
                    name_error = "profesional del constructor"
                }
            }

            if (JSON.parse(localStorage.getItem('inspectorObra')) && JSON.parse(localStorage.getItem('inspectorObra')).length > 0) {
                if (JSON.parse(localStorage.getItem('inspectorProfesional')) && JSON.parse(localStorage.getItem('inspectorProfesional')).length == 0) {
                    hay_error = true;
                    name_error = "profesional del inspector"
                }
            }

            if (JSON.parse(localStorage.getItem('revisorCalculo')) && JSON.parse(localStorage.getItem('revisorCalculo')).length > 0) {
                if (JSON.parse(localStorage.getItem('revisorProfesional')) && JSON.parse(localStorage.getItem('revisorProfesional')).length == 0) {
                    console.log("falta el dato: revisorProfesional");
                    hay_error = true;
                    name_error = "profesional del revisor"
                }
            }

            if (hay_error) {
                swal({
                    type: 'error',
                    title: `Faltan campos obligatorios`,
                    text: `Por favor, revisar la sección de ${name_error}, por posibles datos requeridos.`,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(() => {
                });
            } else {

                if (archivos) {
                    if (archivos['archivosSubidos'] === true || archivos == '{"archivosSubidos":true}') this.forward(wizard);
                    if (archivos['archivosSubidos'] === false || archivos == '{"archivosSubidos":false}') {
                        swal({
                            type: 'error',
                            title: "Aún no subes los archivos obligatorios",
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false
                        }).then(() => {
                        });
                    }

                } else {
                    this.forward(wizard);
                }
            }
        } else {
            if (archivos) {
                if (archivos['archivosSubidos'] === true) {
                    this.forward(wizard);
                }
                if (archivos['archivosSubidos'] === false) {
                    swal({
                        type: 'error',
                        title: "Aún no subes los archivos obligatorios",
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    }).then(() => {
                    });
                }
            } else {
                this.forward(wizard);
            }
        }
    }

    forward(w) {
        if (this.step < this.totalSteps - 1) {
            this.step++;
            this.myStepper.next();
            this.changeMinMaxSteps(true);
        }

    }

    back(w) {

        if (this.step > 0) {
            this.step--;
            this.myStepper.previous();
            this.changeMinMaxSteps(false);
        }
    }

    stepSelectionChange(event: StepperSelectionEvent) {
        this.step = event.selectedIndex;
    }

    allStorage() {

        return Object.keys(localStorage)
            .reduce((obj, k) => {
                if (k == 'form' || k == 'formId' || k == 'formTitle' || k == 'ZipURL' || k == 'formIdOK' || k == 'tipo_solOK' || k == 'docs_checkedOK' || k == 'docs_checked' || k == 'archivos_marcados' || k == 'antecedentes_status') {// para que 3.10 llegue completo  
                    return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? localStorage.getItem(k) : '' }
                } else {
                    return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? JSON.parse(localStorage.getItem(k)) : '' }
                }
            }, {});
    }

    verBorradores() {
        const formOptions = this.dialog.open(BorradoresComponent, {
            width: '690px',
            maxWidth: '75vw'
        });
    }


    guardar_expediente() {
        this.listo = false;
        this.spinner.show();

        this.formulariofinal = this.allStorage();


        this.filemaker.guardarExpediente(this.formulariofinal).subscribe(
            response => {
                this.listo = this.resumen;
                this.spinner.hide();
                if (response) {
                    this.store.dispatch(new FormActions.FormUpdate('0', ''))
                    localStorage.clear();
                    sessionStorage.removeItem('borrador');
                    swal({
                        type: 'success',
                        title: 'Solicitud enviada',
                        text: `
                                        <p>Su solicitud de pre-ingreso fue recepcionada, una vez revisado sus documentos, la dirección de obras tomará contacto con usted, con el estado de su solicitud, la cual puede ser aceptada o rechazada.</p>
                                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                    }).then(
                        () => {
                            this._router.navigate(['/expedientes'])
                        }
                    );
                }
            },
            error => {
                this.listo = true
                console.log(error)
                this.spinner.hide();
                //alert("Error: No se pudo guardar la solicitud")
                swal({
                    type: 'error',
                    title: "No se pudo guardar la solicitud",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                }).then(
                    () => {

                    }
                );


            }
        )
    }

    onAction(event?) {
        console.log(event)
    }

    finalizeStep() {
        console.log("el finalize")
    }

    scrollToTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    scrollToBottom(): void {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }


}